const CLIENT_TOKEN_ERROR_CODES = [
	"CLIENT_AUTHORIZATION_INVALID",
	"CLIENT_AUTHORIZATION_INSUFFICIENT",
	"CLIENT_INVALID_AUTHORIZATION"
];

const MAX_NESTED_ERROR_DEPTH = 5;

export function isClientTokenError(err: unknown, depth = 0): boolean {
	if (err === null || typeof err !== "object") {
		return false;
	}
	if (depth > MAX_NESTED_ERROR_DEPTH) {
		return false;
	}

	const { code, details } = err as {
		code?: unknown;
		details?: { originalError?: unknown };
	};

	if (typeof code === "string" && CLIENT_TOKEN_ERROR_CODES.includes(code)) {
		return true;
	}

	return isClientTokenError(details?.originalError, depth + 1);
}
